/* eslint-disable no-multi-assign */
import { Window } from '../../00_IMMEDIATE/Window';
import OMT_UI_SquareButton, { BUTTONCOLOURS } from '../../OMT_UI/OMT_UI_SquareButton';
// import { OMT_UI_SquareButton } from "../../OMT_UI/Buttons/OMT_UI_SquareButton";

const ScoreEntryIndices = {
  User1: 0,
  User2: 1,
  Player: 2,
};

/**
 * Class for animated friend beaten display
 */
class Window_friendBeaten extends Window {
  /**
    * constructor
    * @param {Number} lvlIndex
    * @param {Object} user1
    * @param {Object} [user2]
    * @param {Object} [offset] friendBeaten
    * @param {Number} offset.x
    * @param {Number} offset.y
   */
  constructor(parentWindow, lvlIndex, player, user1, user2, offset, leaderboard) {
    super(parentWindow);

    this._mainJsonData = G.json['ui/popUps/highscoreBeaten'];
    this._threeEntries = Boolean(user2);
    this._closed = false;
    this._playerRank = null;
    this._user1Rank = null;
    this._user2Rank = null;
    this._avatarManager = G.HighscorePanel2Helper.createAvatarsManager(
      game,
      game.make.image(0, 0, 'leaderboard2', 'lb2_avatar_mask'),
      G.AsyncUtils.createPhaserStateStatusTracker(game),
      {
        width: 80,
        height: 80,
      },
    );

    // Apply parameterised offset if it exists
    if (offset) {
      this.x += offset.x;
      this.y += offset.y;
    }

    if (leaderboard) {
      leaderboard.makeHidden();
    }
    this._mainUI = this._createMainUI();
    this.add(this._mainUI.rootElement);

    // Handle modifying entry elements with correct data
    if (this._threeEntries) {
      this._user2Rank = this._handleEntry(user2, ScoreEntryIndices.User2, this._avatarManager);
    }
    this._user1Rank = this._handleEntry(user1, ScoreEntryIndices.User1, this._avatarManager);
    this._playerRank = this._handleEntry(player, ScoreEntryIndices.Player, this._avatarManager);

    if (!this._threeEntries) {
      this._user1Rank.y += 70;
      this._playerRank.y -= 70;
    }

    this._mainUI.exports.getFirst('sendChallengeSubText').rootElement.setText(
      OMT.language.getText('Send a challenge to %NAME%?').replace('%NAME%', user1.name),
    );
    this._mainUI.exports.getFirst('headingText').rootElement.setText(
      `${OMT.language.getText('Level')} ${(lvlIndex + 1).toString()}`,
    );

    const noThanksClick = () => {
      this.closeWindow();
    };
    const challengeClick = () => {
      this._challengeButton.inputEnabled = false;
      // this._challengeButton.toggleButton(BUTTONSTATE.DISABLED);
      OMT.social.sendLevelHighscoreBeatMsg(
        player,
        user1,
        lvlIndex,
        player.score - user1.score,
        (success) => {
          if (success) this.closeWindow();
          else {
            this._challengeButton.inputEnabled = true;
            // this._challengeButton.toggleButton(BUTTONSTATE.ENABLED);
          }
        },
      );
    };
    this._noThanksButton = new OMT_UI_SquareButton(120, 0, {
      button: {
        tint: BUTTONCOLOURS.red,
        dimensions: {
          width: 166,
          height: 86,
        },
        extraDetail: false,
      },
      text: {
        string: OMT.language.getText('No, thanks'),
        textStyle: {
          style: 'font-white',
          fontSize: 68,
        },
      },
      options: {
        clickFunction: {
          onClick: noThanksClick.bind(this),
        },
      },
    });
    this._challengeButton = new OMT_UI_SquareButton(-140, 0, {
      button: {
        tint: BUTTONCOLOURS.blue,
        dimensions: {
          width: 166,
          height: 86,
        },
      },
      text: {
        string: OMT.language.getText('Challenge'),
        textStyle: {
          style: 'font-white',
          fontSize: 68,
        },
      },
      options: {
        clickFunction: {
          onClick: challengeClick.bind(this),
        },
      },
    });
    this._noThanksButton.y = this._challengeButton.y = game.world.bounds.y + (game.height / 2) + this._noThanksButton.height / 4;
    this.add(this._challengeButton);
    this.add(this._noThanksButton);

    this._playAnimation();

    // "... you can add line.ogg as a sound for when this overlay appears"
    G.sfx.line.play();
  }

  /**
   * create the main UI
   */
  _createMainUI() {
    const ui = G.UI.createUIElement(
      game,
      this._mainJsonData,
      1, 1,
      (key) => G.json[key],
      this._threeEntries
        ? undefined : G.UI.createFilterToSkipExportNames(['otherRankGroup1']),
    );
    G.UI.resize(
      ui.rootElement,
      this._mainJsonData.desiredSize[0],
      this._mainJsonData.desiredSize[1],
    );
    ui.rootElement.x -= ui.rootElement.width * 0.7;
    ui.rootElement.y -= ui.rootElement.height * 0.42;
    return ui;
  }

  /**
   * setup the avatars
   * @param {*} userData
   * @param {*} entryIndex
   * @param {*} avatarManager
   */
  _handleEntry(userData, entryIndex, avatarManager) {
    const isPlayer = (entryIndex === ScoreEntryIndices.Player);
    const entry = this._mainUI.exports.getFirst(
      isPlayer ? 'playerRankGroup' : (`otherRankGroup${entryIndex.toString()}`),
    );

    // Set background
    if (isPlayer) {
      (entry.exports.getFirst('friendBg').rootElement).visible = false;
    } else {
      (entry.exports.getFirst('playerBg').rootElement).visible = false;
    }

    // Set score
    (entry.exports.getFirst('text_score').rootElement).setText(
      userData.score,
    );

    // Set if above or below player's rank
    if (isPlayer) {
      (entry.exports.getFirst('downArrowUser1').rootElement).visible = false;
    } else {
      (entry.exports.getFirst('upArrowUser1').rootElement).visible = false;
    }

    // Set name
    (entry.exports.getFirst('user1Name').rootElement).setText(userData.name);

    // Handle emplacing the avatar on load
    avatarManager.tryPreload(entryIndex.toString(), [userData.image]);
    const { promise } = avatarManager.getFuturePromise(entryIndex.toString());
    promise.then(() => {
      if (this._closed) return;
      avatarManager.emplaceAvatar(
        (entry.exports.getFirst('profileImage1').rootElement),
        userData.image,
      );
    });

    return entry.rootElement;
  }

  /**
   * play animations
   */
  _playAnimation() {
    const footerGroup = this._mainUI.exports.getFirst('footerGroup').rootElement;
    footerGroup.alpha = 0;
    this._challengeButton.alpha = 0;
    this._noThanksButton.alpha = 0;

    const delay = G.AsyncUtils.createScheduler(game);
    delay.rescheduleAction(() => {
      // do animation
      game.add
        .tween(this._playerRank.scale)
        .to({ x: 1.2, y: 1.2 }, 600, Phaser.Easing.Sinusoidal.Out, true)
        .onComplete.add(() => {
          delay.rescheduleAction(() => {
            game.add
              .tween(this._playerRank)
              .to({ y: this._user1Rank.y }, 500, Phaser.Easing.Circular.InOut, true)
              .onComplete.add(() => {
                delay.rescheduleAction(() => {
                  game.add
                    .tween(this._playerRank.scale)
                    .to({ x: 1, y: 1 }, 600, Phaser.Easing.Sinusoidal.Out, true)
                    .onComplete.add(() => {
                      game.add
                        .tween(footerGroup)
                        .to({ alpha: 1 }, 700, Phaser.Easing.Sinusoidal.Out, true);
                      game.add
                        .tween(this._challengeButton)
                        .to({ alpha: 1 }, 700, Phaser.Easing.Sinusoidal.Out, true);
                      game.add
                        .tween(this._noThanksButton)
                        .to({ alpha: 1 }, 700, Phaser.Easing.Sinusoidal.Out, true);
                    });
                }, 400);
              });

            if (this._threeEntries) {
              game.add
                .tween(this._user1Rank)
                .to({ y: this._user2Rank.y }, 800, Phaser.Easing.Bounce.Out, true);
              game.add
                .tween(this._user2Rank)
                .to({ y: this._playerRank.y }, 800, Phaser.Easing.Bounce.Out, true);
            } else {
              game.add
                .tween(this._user1Rank)
                .to({ y: this._playerRank.y }, 800, Phaser.Easing.Bounce.Out, true);
            }
          }, 200);
        });
    }, 700);
  }

  /**
   * close window
   */
  closeWindow() {
    this._closed = true;
    super.closeWindow();
  }
}

// create global references
if (!window.Windows) window.Windows = {};
Windows.friendBeaten = Window_friendBeaten;
